import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

const Kvkk = ({ closeModal }) => {
  const { t } = useTranslation();

  useEffect(() => {
    document.body.style.overflow = "hidden";
    document.body.style.overflowX = "hidden";

    return () => {
      document.body.style.overflow = "";
      document.body.style.overflowX = "";
    };
  }, []);

  return (
    <div
      className="fixed inset-0 z-[100] flex items-start justify-center bg-[#1c1c29]/20 backdrop-blur-md transition-opacity duration-300 px-2 sm:px-4 py-6 overflow-y-auto"
      aria-labelledby="kvkk-modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        className="relative bg-[#1c1c29] backdrop-blur-lg rounded-lg shadow-xl w-full max-w-[95vw] sm:max-w-3xl p-4 sm:p-6 text-white"
        aria-describedby="kvkk-modal-description"
      >
        <button
          onClick={closeModal}
          className="absolute top-2 right-2 sm:top-4 sm:right-4 text-[#dcbc5c] text-2xl font-bold hover:scale-110 transition-transform"
          aria-label="Kapat"
        >
          ×
        </button>

        <h1
          id="kvkk-modal-title"
          className="text-xl sm:text-2xl font-bold mb-4 text-center"
          aria-label={t("kvkk_title")}
        >
          {t("kvkk_title")}
        </h1>
        <p
          id="kvkk-modal-description"
          className="text-sm sm:text-base mb-6 text-center font-medium"
          aria-label={t("kvkk_law")}
        >
          {t("kvkk_law")}
        </p>

        <p
          className="text-sm sm:text-base mb-4"
          dangerouslySetInnerHTML={{ __html: t("kvkk_intro") }}
          aria-label={t("kvkk_intro")}
        />

        <h2
          className="text-base sm:text-lg font-bold mb-2 text-[#dcbc5c]"
          aria-label={t("kvkk_processed_data")}
        >
          {t("kvkk_processed_data")}
        </h2>
        <ul
          className="list-disc pl-4 sm:pl-6 mb-4 space-y-1 text-sm sm:text-base"
          aria-label={t("data_list")}
        >
          {t("data_list", { returnObjects: true }).map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>

        <h2
          className="text-base sm:text-lg font-bold mb-2 text-[#dcbc5c]"
          aria-label={t("kvkk_purpose")}
        >
          {t("kvkk_purpose")}
        </h2>
        <ul
          className="list-disc pl-4 sm:pl-6 mb-4 space-y-1 text-sm sm:text-base"
          aria-label={t("purpose_list")}
        >
          {t("purpose_list", { returnObjects: true }).map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>

        <h2
          className="text-base sm:text-lg font-bold mb-2 text-[#dcbc5c]"
          aria-label={t("kvkk_legal")}
        >
          {t("kvkk_legal")}
        </h2>
        <ul
          className="list-disc pl-4 sm:pl-6 mb-4 space-y-1 text-sm sm:text-base"
          aria-label={t("legal_list")}
        >
          {t("legal_list", { returnObjects: true }).map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>

        <h2
          className="text-base sm:text-lg font-bold mb-2 text-[#dcbc5c]"
          aria-label={t("kvkk_transfer")}
        >
          {t("kvkk_transfer")}
        </h2>
        <p
          className="text-sm sm:text-base mb-4"
          aria-label={t("transfer_info")}
        >
          {t("transfer_info")}
        </p>

        <h2
          className="text-base sm:text-lg font-bold mb-2 text-[#dcbc5c]"
          aria-label={t("kvkk_rights")}
        >
          {t("kvkk_rights")}
        </h2>
        <ul
          className="list-disc pl-4 sm:pl-6 mb-4 space-y-1 text-sm sm:text-base"
          aria-label={t("rights_list")}
        >
          {t("rights_list", { returnObjects: true }).map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>

        <h2
          className="text-base sm:text-lg font-bold mb-2 text-[#dcbc5c]"
          aria-label={t("kvkk_contact")}
        >
          {t("kvkk_contact")}
        </h2>
        <p
          className="text-sm sm:text-base"
          dangerouslySetInnerHTML={{ __html: t("contact_info") }}
          aria-label={t("contact_info")}
        />
      </div>
    </div>
  );
};

export default Kvkk;
